import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UADetect as UADetectClass, uaDetectToken } from 'go-modules/detect/ua-detect.service';
import type { GoToastOptions } from '@go-modules/interfaces/go-toast-options';
import { GoToastStatusType } from '@go-modules/enums/go-toast-status-type';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'ngx-go-toast',
	templateUrl: './go-toast.component.html',
	styleUrls: ['./go-toast.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class NgxGoToastComponent implements OnInit, OnDestroy {

	public toastDetails: GoToastOptions;
	public ToastStatusTypes = GoToastStatusType;
	public hideToastTime: null|number;
	public readonly HIDE_TOAST_TIME = 5000;

	private toastTimeout;
	private destroyed$ = new Subject();

	constructor (
		@Inject(uaDetectToken) public UADetect: UADetectClass,
		private cdr: ChangeDetectorRef,
		private goToastService: NgxGoToastService
	) {}

	public ngOnInit () {
		this.goToastService.toastObserver.pipe(takeUntil(this.destroyed$)).subscribe((toastOptions: GoToastOptions) => {
			this.setToastDetails(toastOptions);
		});
	}

	public ngOnDestroy () {
		this.destroyed$.next(null);
		this.destroyed$.complete();
		if (this.toastTimeout) {
			clearTimeout(this.toastTimeout);
		}
	}

	public shouldShowToast () {
		return !!this.toastDetails;
	}

	public undoAction () {
		this.toastDetails.undo();
		this.closeToast();
	}

	public closeToast (): void {
		this.toastDetails = null;
		this.cdr.detectChanges();
	}

	private setToastDetails (data: GoToastOptions): void {
		this.hideToastTime = data.hideToastTime ?? this.HIDE_TOAST_TIME;

		clearTimeout(this.toastTimeout);

		this.toastDetails = data;
		this.cdr.detectChanges();

		this.toastTimeout = setTimeout(() => {
			this.closeToast();
		}, this.hideToastTime);
	}
}
